import { render } from "./BaseLayoutView.vue?vue&type=template&id=4502f9fa&ts=true"
import script from "./BaseLayoutView.vue?vue&type=script&lang=ts"
export * from "./BaseLayoutView.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\02_システム\\20_帳票テンプレート\\02_開発\\report-template\\web-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__